import React from 'react';
import { createRoot } from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';

import * as Sentry from '@sentry/react';
// Styles
import '@fontsource-variable/inclusive-sans';
import 'ag-grid-enterprise';

// Constants
import envConfig from './services/env-config';

// Components
import App from './AppComposer';
import './index.css';

if (['production', 'staging', 'development'].includes(envConfig.ENVIRONMENT)) {
    Sentry.init({
        dsn: envConfig.SENTRY_DSN,
        integrations: [
            Sentry.browserSessionIntegration(),
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [envConfig.API_URL],
        replaysSessionSampleRate: 0.05,
        replaysOnErrorSampleRate: 1.0,
        environment: envConfig.ENVIRONMENT,
        ignoreSpans: [
            {
                op: 'http.client',
                name: 'segment',
            },
        ],
    });
}

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
